query userConfiguration {
  userConfiguration: allUserConfigs {
    nodes {
      oddsFormatType
      bookmakerGatewayPriority
      betTickerColumnOrder
    }
  }
}
